/** Панель инструментов: отмена, повтор, ластик, заметки, подсказка.
 *
 * Пять равных ячеек. Только «Заметки» — переключатель, и включённое
 * состояние заливается акцентом, а не обводится: обводка читается как
 * фокус, а не как режим.
 *
 * Недоступное действие приглушается до 45%, но остаётся на месте.
 * Перестраивать панель под пальцем — верный способ заставить промахнуться.
 */

import { t } from '../i18n'

export interface ToolbarProps {
  canUndo: boolean
  canRedo: boolean
  canErase: boolean
  notesMode: boolean
  disabled?: boolean
  onUndo: () => void
  onRedo: () => void
  onErase: () => void
  onToggleNotes: () => void
  onHint: () => void
}

export function Toolbar({
  canUndo,
  canRedo,
  canErase,
  notesMode,
  disabled = false,
  onUndo,
  onRedo,
  onErase,
  onToggleNotes,
  onHint,
}: ToolbarProps) {
  return (
    <div className="toolbar">
      <ToolButton
        icon="↺"
        label={t('game.undo')}
        disabled={disabled || !canUndo}
        onClick={onUndo}
      />
      <ToolButton
        icon="↻"
        label={t('game.redo')}
        disabled={disabled || !canRedo}
        onClick={onRedo}
      />
      <ToolButton
        icon="⌫"
        label={t('game.erase')}
        disabled={disabled || !canErase}
        onClick={onErase}
      />
      <ToolButton
        icon="✎"
        label={t('game.notes')}
        active={notesMode}
        disabled={disabled}
        onClick={onToggleNotes}
      />
      <ToolButton icon="◇" label={t('game.hint')} disabled={disabled} onClick={onHint} />
    </div>
  )
}

interface ToolButtonProps {
  icon: string
  label: string
  disabled: boolean
  active?: boolean
  onClick: () => void
}

function ToolButton({ icon, label, disabled, active = false, onClick }: ToolButtonProps) {
  return (
    <button
      type="button"
      className={`toolbar__button ${active ? 'toolbar__button--on' : ''}`.trim()}
      disabled={disabled}
      onClick={onClick}
      aria-pressed={active}
    >
      <span className="toolbar__icon">{icon}</span>
      <span className="toolbar__label">{label}</span>
    </button>
  )
}
